export default __webpack_public_path__ + "static/media/earnIcon.32c19b1b.svg";